import { render, staticRenderFns } from "./edit-textarea.vue?vue&type=template&id=21ca4ca7&scoped=true&"
import script from "./edit-textarea.vue?vue&type=script&lang=js&"
export * from "./edit-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca4ca7",
  null
  
)

export default component.exports